// extracted by mini-css-extract-plugin
export default {"title":"fahrzeug-select_title__NVY9H","select":"fahrzeug-select_select__BLIq5"};